import React from "react";
import styled from "styled-components";
import { useInView } from "react-intersection-observer";
import PropTypes from "prop-types";

import { easingSeconds } from "./";

const HoverWrap = styled.div`
    overflow: hidden;
    height: 100%;

    img {
        opacity: 1;
        transition: opacity ${easingSeconds};

        &:hover {
            opacity: 0.6;
        }
    }
`;

const LazyLoadImgBodyIntersectionObserver = ({ src, className, alt }) => {
    const [ref, inView] = useInView({ triggerOnce: true, threshold: 0 });
    return (
        <HoverWrap ref={ref} className={className}>
            {inView && <img src={src} alt={alt} title={alt} />}
        </HoverWrap>
    );
};

LazyLoadImgBodyIntersectionObserver.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    className: PropTypes.string
};

const LazyLoadImgBodyNoIntersectionObserver = ({ src, className, alt }) => {
    return (
        <HoverWrap className={className}>
            <img src={src} alt={alt} title={alt} />
        </HoverWrap>
    );
};

LazyLoadImgBodyNoIntersectionObserver.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    className: PropTypes.string
};

const LazyLoadImgBody = window.IntersectionObserver
    ? LazyLoadImgBodyIntersectionObserver
    : LazyLoadImgBodyNoIntersectionObserver;

const LazyLoadImg = styled(LazyLoadImgBody)`
    width: ${props => props.width};

    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
        max-width: 100%;
        height: auto;
    }
`;

LazyLoadImg.propTypes = {
    src: PropTypes.string.isRequired,
    className: PropTypes.string,
    width: PropTypes.string,
    title: PropTypes.string
};

export { LazyLoadImg };
